import img1 from './Assets/images/iyns_placeholder.png';

const imageMap = {
  'factory-producing-co2-pollution.jpg': img1,
};

export default imageMap;
